import { ON_FIRMWARE_INFO_RECEIVED, ON_BUILD_INFO_RECEIVED, ON_TERMINAL_INFO_RECEIVED } from '../actions/peripheral'

const defaultState = {
  peripheralStatus: 'ready',
  firmwareInfoReceived: false,
  buildInfoReceived: false,
  firmwareInfo: {},
  buildInfo: {},
}

const peripheralStatuses = {
  LANE_ATTACHED: 'attached',
  LANE_REMOVED: 'not connected',
  LANE_OPENED: 'ready',
  LANE_CLOSED: 'attached',
}

const peripheralReducer = (state = defaultState, action) => {
  const peripheralStatus = peripheralStatuses[action.type]

  if (action.type === ON_FIRMWARE_INFO_RECEIVED) {
    return {
      ...state,
      firmwareInfoReceived: true,
      firmwareInfo: {
        ...(state?.firmwareInfo ?? {}),
        ...(action?.payload ?? {}),
      }
    }
  }

  if (action.type === ON_BUILD_INFO_RECEIVED) {
    return {
      ...state,
      buildInfoReceived: true,
      buildInfo: {
        ...(state?.buildInfo ?? {}),
        ...(action?.payload ?? {}),
      }
    }
  }

  if (action.type === ON_TERMINAL_INFO_RECEIVED) {
    return {
      ...state,
      terminalInfoReceived: true,
      terminalInfo: {
        ...(state?.terminalInfo ?? {}),
        ...(action?.payload ?? {}),
      }
    }
  }

  if (peripheralStatus) {
    return {
      ...state,
      peripheralStatus,
    }
  }

  return state
}

export default peripheralReducer
